import React from 'react';
import MassUpdateControlsLayout from '../../../shared/widgets/MassUpdate/MassUpdateControlsLayout';
import DeleteButton from './DeleteButton';
import DownloadButton from './DownloadButton';
import { useMassUpdateServiceRequired } from 'ui-builder';
import AddToPortalButton from './AddToPortalButton';
import RemoveFromPortalButton from './RemoveFromPortal';

export default function ProjectDocumentsMassUpdateControls() {

  const massUpdateService = useMassUpdateServiceRequired();

  if (massUpdateService.isEnabled()) {
    return (
      <MassUpdateControlsLayout>
        <DownloadButton />
        <DeleteButton />
        <AddToPortalButton />
        <RemoveFromPortalButton />
      </MassUpdateControlsLayout>
    );
  } else {
    return null;
  }
}
